export function validateEmail(email) {
  if (email.length === 0) return false;
  const re = /\S+@\S+\.\S+/;
  return re.test(email);
}
